import axios from 'axios';
import './PlanForm.css';
import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
// import axios from 'axios';



export default function PlanForm() {
    const [form, setForm] = useState({
        city_id: '',
        company_name: '',
        area_id: '',
        teamSize: '',
        month: '',
        agreed: false,
        hrName: '',
        hrPhone: ''
    });

    const [cityId, setCityId] = useState('');
    const [leadarea, setLeadarea] = useState([]);
    const [citydata, setCityData] = useState([]);

    const [areYouHr, setAreYouHr] = useState('');;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Submitted form data:', form);
        Swal.fire({
            position: "center-center",
            icon: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
        });
        setForm({
            city_id: '',
            company_name: '',
            area_id: '',
            teamSize: '',
            month: '',
            agreed: false,
            hrName: '',
            hrPhone: ''
        });
        setAreYouHr(false);
    };



    // useEffect(() => {
    //     const apiUrl = "https://partywitty.com/master/Api/getDataPost/AreaLead";
    //     if (cityId) {
    //         const formData = new FormData();
    //         formData.append("city_id", cityId);
    //         axios
    //             .post(apiUrl, formData)
    //             .then((response) => {
    //                 setLeadarea(response.data.data);
    //             })
    //             .catch((error) => {
    //                 console.error("API error:", error);
    //             });
    //     }
    // }, [cityId]);

    // useEffect(() => {
    //     axios
    //         .get("https://partywitty.com/master/Api/getData/getAreaLead")
    //         .then((response) => {
    //             setCityData(response.data.data);
    //         })
    //         .catch((error) => {
    //             console.log("Error fetching area data:", error);
    //         });
    // }, []);



        //  <div className="dropdown-group">
        //                 <FloatingLabelSelect
        //                     label="City"
        //                     name="city"
        //                     value={formData.city}
        //                     onChange={handleLocationChange}
        //                     options={[
        //                         { id: "", name: "Select a city" }, // placeholder option
        //                         ...citydata
        //                     ]}
        //                     valueKey="name"
        //                 />
    
    
        //                 <FloatingLabelSelect
        //                     name="area"
        //                     label="Area"
        //                     value={selectedArea ? selectedArea.id : ""}
        //                     onChange={handleAreaChange}
        //                     options={[{ id: "", name: "Select a area" }, ...leadarea]}
        //                     valueKey="id"
        //                 />
        //             </div>


    return (
        <div className="form-container">
            <form className="floating-form" onSubmit={handleSubmit}>
                <div className='form-row'>

                    <div className={`form-group ${form.city ? 'filled' : ''}`}>
                        <input type="text" name="city" value={form.city} onChange={handleChange} required />
                        <label>City</label>
                    </div>

                    <div className={`form-group ${form.area ? 'filled' : ''}`}>
                        <input type="text" name="area" value={form.area} onChange={handleChange} required />
                        <label>Area</label>
                    </div>
                </div>

                <div className={`form-group ${form.company ? 'filled' : ''}`}>
                    <input type="text" name="company" value={form.company} onChange={handleChange} required />
                    <label>Company Name</label>
                </div>



                <div className="form-row">
                    <div className={`form-group ${form.teamSize ? 'filled' : ''}`}>
                        <select name="teamSize" value={form.teamSize} onChange={handleChange} required>
                            <option value="" disabled hidden></option>
                            <option value="1–10">1–10</option>
                            <option value="11–20">11–20</option>
                            <option value="21–50">11–20</option>
                            <option value="51–100">51–100</option>
                            <option value="100 and above">100 and above</option>
                        </select>
                        <label>Team Size</label>
                    </div>
                </div>

                <div className="form-agreement-section-hr">
                    <label>Are you an HR or the Concerned person?</label>
                    <div className="radio-group">
                        <label>
                            <input
                                type="radio"
                                name="areYouHr"
                                value="yes"
                                checked={areYouHr === "yes"}
                                onChange={() => setAreYouHr("yes")}
                            />
                            Yes
                        </label>
                        <label>
                            <input
                                type="radio"
                                name="areYouHr"
                                value="no"
                                checked={areYouHr === "no"}
                                onChange={() => setAreYouHr("no")}
                            />
                            No
                        </label>
                    </div>
                </div>


                {areYouHr == 'no' && (
                    <div className="form-row">
                        <div className={`form-group ${form.hrName ? 'filled' : ''}`}>
                            <input
                                type="text"
                                name="hrName"
                                value={form.hrName}
                                onChange={handleChange}
                                required={areYouHr}
                            />
                            <label>HR Name</label>
                        </div>

                        <div className={`form-group ${form.hrPhone ? 'filled' : ''}`}>
                            <input
                                type="number"
                                name="hrPhone"
                                value={form.hrPhone}
                                onChange={handleChange}
                                required={areYouHr}
                            />
                            <label>HR Phone Number</label>
                        </div>
                    </div>
                )}



                <div className="form-agreement-section">
                    <div className="form-agree">
                        <input
                            type="checkbox"
                            id="agree"
                            name="agreed"
                            checked={form.agreed}
                            onChange={handleChange}
                        />
                        <label htmlFor="agree">
                            I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
                        </label>
                    </div>

                    <button type="submit" className="submit-btn">
                        Plan My Recreation Day
                    </button>
                </div>
            </form>
        </div>
    );
}
